
import { computed, defineComponent, PropType } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import OkInvoiceStatuses from '@/modules/OktellModule/components/OkInvoiceStatuses/index.vue'

import { InvoiceT } from '@/core/types/orders.types'

export default defineComponent({
    components: {
        Loader,
        OkInvoiceStatuses,
    },
    props: {
        invoice: {
            type: Object as PropType<InvoiceT>,
            default: null,
        },
        clientSlaDate: {
            type: String,
            default: null,
        },
        statusesLoading: {
            type: Boolean,
            default: false,
        },
        statusesFailed: {
            type: Boolean,
            default: false,
        },
        statuses: {
            type: Array as PropType<any[]>,
            default: () => [],
        },
        problemsLoading: {
            type: Boolean,
            default: false,
        },
        problemsFailed: {
            type: Boolean,
            default: false,
        },
        problemsEmpty: {
            type: Boolean,
            default: false,
        },
        problems: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
    },
    emits: ['reload-statuses', 'reload-problems'],
    setup(props, { emit }) {
        const onReloadStatuses = () => {
            emit('reload-statuses')
        }

        const onReloadProblems = () => {
            if (!props.problemsFailed) return
            emit('reload-problems')
        }

        const getCostPrediction = () => {
            if (props.invoice.cost_prediction === -1) {
                return 'Нет в биллинге'
            }

            if (props.invoice.cost_prediction === null) {
                return 'Будет доступно после обработки груза'
            }

            if (props.invoice.status) {
                if ([204, 212, 503].includes(props.invoice.status.code)) {
                    return 'Не указана'
                }

                if (props.invoice.status.code === 211) {
                    return `${props.invoice.cost_prediction} ₸`
                }

                return `от ${props.invoice.cost_prediction} ₸`
            }

            return 'Не указана'
        }

        const takeDate = computed(() => {
            if (props.invoice.take_date) {
                const take_date = props.invoice.take_date.split('-').reverse().join('.')

                if (props.invoice.period) {
                    return `${take_date} (Период: ${props.invoice.period})`
                }

                return take_date
            }

            return null
        })

        return {
            onReloadStatuses,
            onReloadProblems,
            getCostPrediction,
            takeDate,
        }
    },
})
